import { getHomePath } from '../routing/flowSelectors';

import { CART_STATUS } from './cartModule';
import { getCartStatus } from './cartSelectors';
import { cartPostConditions, cartStepSkippable } from './cartStepSelectors';



const cartStepConfig = {
    
    
    component: () => import('./Cart'),
    flow: 'postBuy',
    hideCartLink: true,
    flowProps: (state) => {
        const cartStatus = getCartStatus(state);

        return {
            cartStatus
        };
    },
    isReady: (state, ownProps) => {
        const { cartStatus } = ownProps;
        return cartStatus !== CART_STATUS.PROCESSING;
    },
    canLoad: (state, ownProps) => {
        const { cartStatus } = ownProps;
        
        return { isAllowedOrPath: cartStatus !== CART_STATUS.INVALID || getHomePath(state) };
    },
    postConditions: cartPostConditions,
    
    
    getSubmitMessage: null,
    canSkip: state => (
        cartStepSkippable(state)
    )
};

export default cartStepConfig;
